import api from './api';

// Helper para extrair dados da resposta
const extractData = (data) => {
  if (data && typeof data === 'object' && data.$values) {
    return data.$values;
  }
  return data;
};

const placesService = {
  // Listar todos os dados da página (estrutura normalizada)
  // Retorna: { professionals, services, payments, places }
  getAll: async () => {
    const response = await api.get('/places');
    const data = extractData(response.data);
    
    // Se a API já retorna estrutura normalizada, retorna direto
    if (data && data.professionals && data.services && data.payments && data.places) {
      return data;
    }
    
    // Senão, assume que é array de places (formato antigo) e adapta
    // TODO: Remover essa compatibilidade quando API estiver atualizada
    return {
      professionals: [],
      services: [],
      payments: [],
      places: Array.isArray(data) ? data : []
    };
  },

  // Buscar local por ID
  getById: async (id) => {
    const response = await api.get(`/places/${id}`);
    return extractData(response.data);
  },

  // Criar novo local
  create: async (data) => {
    const response = await api.post('/places', data);
    return extractData(response.data);
  },

  // Atualizar local
  update: async (id, data) => {
    const response = await api.put(`/places/${id}`, data);
    return extractData(response.data);
  },

  // Deletar local
  delete: async (id) => {
    const response = await api.delete(`/places/${id}`);
    return extractData(response.data);
  },
};

export default placesService;
